export default "__VITE_ASSET__Iz5A7X$x__";